import React from "react";

import { useUsers } from "../../../hooks/useUsers";
import { useCurrentUser } from "../../../hooks/useCurrentUser";

interface UserListsProps {
  onEdit: (userId: string) => void;
}

const UserLists: React.FC<UserListsProps> = ({ onEdit }) => {
  const { users } = useUsers();
  const { currentUser } = useCurrentUser();

  return (
    <div className="table-contents">
      <div className="table-main">
        <table>
          <thead>
            <tr>
              <th className="center">権限</th>
              <th>ユーザー名</th>
              <th>審査権限</th>

              {currentUser?.role === "adminMaster" && <th>メールアドレス</th>}
              {currentUser?.role === "adminUser" && <th></th>}

              <th></th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td className="role center">
                  <span
                    className={user.role === "adminMaster" ? "master" : "user"}
                  >
                    {user.role === "adminMaster" ? "管理者" : "一般"}
                  </span>
                </td>

                <td className="name">{user.name}</td>

                <td className={`judge ${user.judge ? "judge-true" : ""}`}>
                  {user.judge ? "あり" : "なし"}
                </td>

                {currentUser?.role === "adminMaster" && <td>{user.email}</td>}

                {currentUser?.role === "adminMaster" && (
                  <td className="edit">
                    <button className="editbtn" onClick={() => onEdit(user.id)}>
                      編集
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserLists;
